import { bus, axios, apiURL } from '../main'

export default {
    state: { // state des Moduls wird direkt auf die Variable state.modulX gemappt
        einladungen: [],
        aktiveEinladungIndx: -1 // Momentan aktive einladung, es kann nur eine sein .. 
    },
    actions: { // call from outside as action: this.$store.dispatch('LOAD_abcd')
        loadEinladungen: async function ({ state }) {
            try {
                var einladungen = await axios.get(apiURL + 'einladungen.cfc?method=getEinladungen')

                einladungen = einladungen.data
                einladungen.map(function(e){ e.EINPUBMSGACTION = JSON.parse(e.EINPUBMSGACTION)})
                state.einladungen = einladungen; //immer alle
            }
            catch (e) {
                bus.$emit('error', 'Einladungen konnten nicht geladen werden ..' + JSON.stringify(e.message))
            }
        },
        /* wurde eine Einladung angenommen ? Ziel erreicht? */
        einladungenGTfinished: async function ({ state }, organisationen) {
            if(state.aktiveEinladungIndx == -1) return
            let einladungOrgID = state.einladungen[state.aktiveEinladungIndx].EINPUBMSGACTION.params.einladung.freigabe.orgid
            let oIndx = organisationen.findIndex(o => o.orgid == einladungOrgID && o.freigabe == true)
            if (oIndx == -1) return
            state.einladungen[state.aktiveEinladungIndx].EINPUBMSGREFUSED = false
            state.einladungen[state.aktiveEinladungIndx].EINPUBMSGTARGETREACHED = true
            await axios.get(apiURL + 'einladungen.cfc?method=setEinladung', { params: { einladung: state.einladungen[state.aktiveEinladungIndx]}})
        }
    },
    mutations: {
        setAktiveEinladung( state, einX) {
            state.aktiveEinladungIndx = state.einladungen.findIndex(e=>e.EINPUBMSGCOMEINPUBID == einX.EINPUBMSGCOMEINPUBID)
        }
    }
}
